import React from 'react';

import styles from './relatedCompanyStyles';

import RecentIdea from 'buyside/components/presentation/RecentIdea/recentIdea';
import Link from 'buyside/components/presentation/Link/link';

import LightbulbIcon from 'buyside/svgs/lightbulb.svg';

import { newIdeaUrl, entityUrl } from 'buyside/util/urlHelper';

const RelatedCompany = ({ entityWithIdea, showUserDetails }) => {
  return (
    <div className={styles.relatedCompany}>
      <h3 className={styles.relatedCompaniesHeading}>
        <Link to={entityUrl(entityWithIdea.id)}>
          {entityWithIdea.name}{' '}
          <small className={styles.ticker}>({entityWithIdea.primarySymbol})</small>
        </Link>
      </h3>
      {entityWithIdea.mostRecentIdea ? (
        <div>
          <strong className={styles.strongText}>Most Recent Idea:</strong>
          <RecentIdea
            idea={entityWithIdea.mostRecentIdea}
            size="small"
            showUserDetails={showUserDetails}
          />
        </div>
      ) : (
        <div className={styles.noIdeaWrap}>
          <LightbulbIcon className={styles.noIdeaIcon} />
          <span className={styles.noIdeaText}>
            No ideas available for this company. <Link to={newIdeaUrl()}>Write one?</Link>
          </span>
        </div>
      )}
    </div>
  );
};

export default RelatedCompany;
